import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { labels } from "../../../../lang/labels";
import { useSelector } from "react-redux";

const TransactionHistoryTable = ({ yearWiseBillLst }) => {
  const lang = useSelector((state) => state.userDetails.lang);

  return (
    <TableContainer>
      <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow
            sx={{
              background: "#c0defb",
              "&:last-child td, &:last-child th": { border: 1 },
              border: 1,
            }}
          >
            <TableCell align="center">{labels.SrNo[lang]}</TableCell>
            <TableCell align="center">{labels.ConsumerNumber[lang]}</TableCell>
            <TableCell align="center">{labels.FYear[lang]}</TableCell>
            <TableCell align="center">{labels.BillNumber[lang]}</TableCell>
            <TableCell align="center">{labels.BalanceAmount[lang]}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {yearWiseBillLst.map((item, index) => {
            return (
              <TableRow key={index}>
                <TableCell align="center" sx={{ border: 1 }}>
                  {index + 1}
                </TableCell>
                <TableCell align="center" sx={{ border: 1 }}>
                  {item.propertyCode || "-"}
                </TableCell>
                <TableCell align="center" sx={{ border: 1 }}>
                  {item.financialYear || "-"}
                </TableCell>
                <TableCell align="center" sx={{ border: 1 }}>
                  {item.billNo || "-"}
                </TableCell>
                <TableCell align="center" sx={{ border: 1 }}>
                  {`${labels.rupee[lang]} `} {item.balanceAmount || "-"}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionHistoryTable;
